/** 支付入口 */
export const PAY_ENTRANCE = {
  /** 入口-快付 */
  TO_PAY: 'toPay',
  /** 入口-被扫 */
  SCAN_PAY: 'scanPay',
  /** 入口-主扫 */
  CTIVE_SCAN: 'activeScan',
}

/** 支付渠道 */
export const PAY_CHANNEL = {
  /** 线上支付 */
  PAY_ONLINE: 0,
  /** 扫码付 */
  PAY_SCAN: 1,
  /** 主扫 */
  PAY_ACTIVE_SCAN: 2,
}

/** 支付类型 */
export const PAY_TYPE = {
  /** 支付 */
  PAY: '01',
  /** 退款 */
  REFUND: '02',
}

/** 支付模式 */
export const PAY_MODE = {
  /** 密码 */
  PASSWORD: '0',
  /** 指纹 */
  FINGER_PRINT: '1',
  /** face id */
  FACE_ID: '2',
}

/** 支付状态/交易状态 */
export const PAY_STATUS = {
  /** 待支付 0 */
  WAIT_PAY: '0',
  /** 交易成功 */
  SUCCESS: '3',
  /** 退款成功 部分退款 */
  REFUND_EXIST: '4',
  /** 交易关闭 全额退款 */
  TRADE_CLOSE: '5',
  /** 交易完成 */
  TRADE_COMPLETED: '6',
  /** 交易关闭 超时 */
  TRADE_CLOSE_TIMEOUT: '7',
  /** 退款中 */
  SOMEREFUND_SUCCESS: 'SOMEREFUND_SUCCESS',
  /** 退款失败 */
  REFUND_FAIL: 'REFUND_FAIL',
  /** 退款成功 */
  REFUND_SUCCESS: 'REFUND_SUCCESS',
}

/** 3ds 认证流程状态 */
export const THIRD_DS_STATE = {
  /** 初始化认证 走3ds2 */
  INITIATE_AUTHENTICATION: 'INITIATE_AUTHENTICATION',
  /** 认证付款方 走3ds1 */
  AUTHENTICATE_PAYER: 'AUTHENTICATE_PAYER',
}
